import { TimeoutErrorTemplate } from "rs-components/TimeoutDialog";
import { reconnect, reconnecting, setPreventNavigation, socketErrorMessage, socketSubscribeMessage, } from "store/knowledge-base-item/knowledge-base-item.actions";
import { setOffline } from "store/global/global.actions";
import { setSimulationPreviewData, getInsightScoreSuccessful, setInsightScoreErrored, getOptimizationPreviewResultSuccessful, setSimulationPreviewError, setOptimizationPreviewTimeoutError, } from "store/rs-workspace/actions/rs-workspace.actions";
import { getSimulationResult, handleCalculationStatusChange, setPredictionTime, } from "store/rs-workspace/actions/results.actions";
import { setRefinementData } from "store/cell-model/cell-model.actions";
import WSService from "./web-socket.service";
import { changeSeats } from "store/licensing/licensing.actions";
export var InvokeRsSocketMethods;
(function (InvokeRsSocketMethods) {
    InvokeRsSocketMethods["SUBSCRIBE"] = "Subscribe";
    InvokeRsSocketMethods["CALCULATE_SIMULATION_PREVIEW"] = "CalculateSimulationPreview";
    InvokeRsSocketMethods["CALCULATE_INSIGHT_PREVIEW"] = "CalculateInsightPreview";
    InvokeRsSocketMethods["CALCULATE_OPTIMIZATION_PREVIEW"] = "CalculateOptimizationPreview";
    InvokeRsSocketMethods["CANCEL_PREVIEW"] = "CancelPreview";
    InvokeRsSocketMethods["WAIT_REFINE_RESULT"] = "WaitRefineResult";
    InvokeRsSocketMethods["IGNORE_REFINE_RESULT"] = "IgnoreRefineResult";
})(InvokeRsSocketMethods || (InvokeRsSocketMethods = {}));
export var IncomingRsSocketMessage;
(function (IncomingRsSocketMessage) {
    IncomingRsSocketMessage["SUBSCRIBED"] = "Subscribed";
    IncomingRsSocketMessage["UNSUBSCRIBED"] = "Unsubscribed";
    IncomingRsSocketMessage["ERROR"] = "Error";
    IncomingRsSocketMessage["CALCULATE_SIMULATION_COMPLETED"] = "CalculateSimulationCompleted";
    IncomingRsSocketMessage["SIMULATION_PREVIEW_CALCULATED"] = "SimulationPreviewCalculated";
    IncomingRsSocketMessage["INSIGHT_PREVIEW_CALCULATED"] = "InsightPreviewCalculated";
    IncomingRsSocketMessage["OPTIMIZATION_PREVIEW_CALCULATED"] = "OptimizationPreviewCalculated";
    IncomingRsSocketMessage["REFINE_COMPLETED"] = "RefineCompleted";
    IncomingRsSocketMessage["SEATS_NUMBER_CHANGED"] = "SeatsNumberChanged";
    IncomingRsSocketMessage["TIMEOUT"] = "Timeout";
    IncomingRsSocketMessage["CALCULATION_STATE_CHANGED"] = "CalculationStateChanged";
    IncomingRsSocketMessage["PREDICTION_TIME"] = "PredictionTimeWasChanged";
})(IncomingRsSocketMessage || (IncomingRsSocketMessage = {}));
const getCallbacks = (emitter) => ({
    methods: {
        [IncomingRsSocketMessage.SUBSCRIBED]: (requestId, seats) => emitter(socketSubscribeMessage({ requestId, seats })),
        [IncomingRsSocketMessage.ERROR]: (requestId, errors) => {
            emitter(socketErrorMessage(errors));
            emitter(setInsightScoreErrored({ requestId, errors }));
            emitter(setSimulationPreviewError({ requestId, data: errors }));
            emitter(setOptimizationPreviewTimeoutError({ requestId, errors: errors?.errors ?? [] }));
        },
        [IncomingRsSocketMessage.CALCULATE_SIMULATION_COMPLETED]: (workspaceId, resultSetId, elementId) => emitter(getSimulationResult({ workspaceId, resultSetId, elementId })),
        [IncomingRsSocketMessage.SIMULATION_PREVIEW_CALCULATED]: (requestId, elementId, result) => {
            emitter(setSimulationPreviewData({ requestId, elementId, graphData: result }));
        },
        [IncomingRsSocketMessage.INSIGHT_PREVIEW_CALCULATED]: (requestId, insightId, weight, inputSetId, result) => {
            emitter(getInsightScoreSuccessful({ requestId, insightId, weight, inputSetId, result }));
        },
        [IncomingRsSocketMessage.OPTIMIZATION_PREVIEW_CALCULATED]: (requestId, elementId, result) => {
            emitter(getOptimizationPreviewResultSuccessful({ requestId, elementId, result }));
        },
        [IncomingRsSocketMessage.REFINE_COMPLETED]: (status, refinement) => {
            emitter(setRefinementData({ refinement, refined: true }));
        },
        [IncomingRsSocketMessage.SEATS_NUMBER_CHANGED]: (seats, occupied) => {
            emitter(changeSeats({ seats, occupied }));
        },
        [IncomingRsSocketMessage.CALCULATION_STATE_CHANGED]: () => {
            emitter(handleCalculationStatusChange());
        },
        [IncomingRsSocketMessage.PREDICTION_TIME]: (predictionTimes) => {
            emitter(setPredictionTime(predictionTimes));
        },
        [IncomingRsSocketMessage.TIMEOUT]: () => {
            emitter(setPreventNavigation(false));
            emitter(socketErrorMessage({
                requestId: 0,
                errors: [TimeoutErrorTemplate],
            }));
            WSService.instance.stop();
        },
    },
    reconnecting: () => emitter(reconnecting()),
    reconnected: () => emitter(reconnect()),
    close: () => emitter(setOffline(true)),
});
export { getCallbacks };
